import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTERS } from '../data';

export const useQuery = () => {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
};

export interface IFailedData {
  text?: {
    header?: string;
    subHeader?: string;
  };
  button?: {
    type: 'primary' | 'secondary';
    title: string;
    path?: string;
  };
}

export const defaultFailData: IFailedData = {
  text: {
    header: 'exception.page.request.fail.caption',
    subHeader: 'exception.page.some.wrong.text',
  },
  button: {
    type: 'secondary',
    title: 'exception.page.some.wrong.back.btn',
    path: ROUTERS.INIT,
  },
};

export const createProfileFailData: IFailedData = {
  text: {
    header: 'exception.page.request.fail.caption',
    subHeader: 'exception.page.fail.create.profile.text',
  },
  button: {
    title: 'create.profile.confirm.btn',
    type: 'secondary',
    path: ROUTERS.CREATE_PROFILE,
  },
};

export const useFailedScreen = () => {
  const navigate = useNavigate();
  const { state } = useLocation() || {};
  const { failedData } = state || {};

  const toFailScreen = (data: IFailedData = defaultFailData) => {
    navigate(ROUTERS.FAILED_SCREEN, { state: { failedData: data } });
  };

  return { failedData, toFailScreen };
};
